import { mapState } from "vuex";

export default {
  computed: {
    ...mapState({
      account: (state) => state.account,
      chainCode: (state) => state.chainCode,
      chainId: (state) => state.chainId,
      platformList: (state) => state.platformList,
      platform: (state) => state.platform,
      pay: (state) => state.pay,
      pairSymbol: (state) => state.pairSymbol,
      pairObj: (state) => state.pairObj,
    })
  },
  watch: {
    // account () {
    //   this.load && this.load();
    // },
  },
  mounted () {
    // this.load && this.load();
  },
  methods: {
    getApiWallet () {
      if (!this.account) return
      if (this.platform.name != 'Hyperliquid') return true
      let apiWallet = localStorage.getItem(`hyperliquid_agent_${this.account}`)
      if (apiWallet) {
        apiWallet = JSON.parse(apiWallet)
        return apiWallet
      } else {
        this.$eventBus.$emit("ShowAgent")
        return
      }
    },
  }
};
